var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("new-edit-page", {
    attrs: {
      "page-title": _vm.$t("NewListItem"),
      "submit-button-label": _vm.$t("Save"),
      "submit-button-disabled": _vm.submitButtonDisabled,
      "is-loading": _vm.loading,
      "one-section-only": ""
    },
    on: { submit: _vm.newListValue },
    scopedSlots: _vm._u([
      {
        key: "wholeSection",
        fn: function() {
          return [
            _c("list-value-form", {
              attrs: {
                "list-value-data": _vm.listValueData,
                type: "create",
                characterMaximumLength: _vm.characterMaximumLength,
                "input-type": _vm.inputType
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71f019fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f019fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/NewListItem.vue
// module id = null
// module chunks = 